import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import IncomingCorrespondenceHandoverContent from '../content/incomingCorrespondenceHandoverContent';
import addHandoverWrapper from '../handoverWrapper';

class IncomingCorrespondenceHandover extends React.Component {
	static getTitle(report) {
		return `Incoming Correspondence ${report.rfiNumber}`;
	}

	render() {
		const report = this.props.report && this.props.report.data[0];
		
		return (
			<div>
				<IncomingCorrespondenceHandoverContent report={report} />
			</div>
		);
	}
}

IncomingCorrespondenceHandover.propTypes = {
	context: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addHandoverWrapper(
	IncomingCorrespondenceHandover, {
		title: 'Incoming Correspondence',
		className: 'incoming-correspondence-handover'
	})
);
